import React, {ButtonHTMLAttributes, ReactNode} from 'react';
import classNames, {Argument} from 'classnames';

interface GenericLinkProps {
  readonly children: ReactNode;
  readonly onClick: React.MouseEventHandler;
  readonly className?: Argument;
}

/**
 * A hyperlink that, when clicked, calls an onClick handler rather than going to a location.
 */
export default class GenericLink extends React.PureComponent<
  GenericLinkProps & ButtonHTMLAttributes<HTMLButtonElement>
> {
  render() {
    // button type="button" means we won't submit forms this is embedded in when clicking...this seems like a
    // reasonable default.
    // See https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#attr-type
    const {children, onClick, className, type = 'button', ...rest} = this.props;

    return (
      <button
        type={type}
        className={classNames('generic-link', 'generic-link-button', className)}
        onClick={onClick}
        {...rest}>
        {children}
      </button>
    );
  }
}
